import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-user-mgt',
  imports: [RouterOutlet],
  templateUrl: './user-mgt.html',
  styleUrl: './user-mgt.css',
})
export class UserMgt {}
